import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { OrgStructureLevel } from './org-structure-level';
export { OrgStructureLevel };
import { orgStructureLevelSchema } from '@schemas/business-objects/org-structure-level';
import { OrganizationFormArray } from './organization-form-group';

export class OrgStructureLevelFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    description: SchemaFormControl;
    organizations: OrganizationFormArray;
  };

  declare value: Partial<OrgStructureLevel>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(orgStructureLevelSchema, OrgStructureLevel, data, options);
  }

  get object(): OrgStructureLevel {
    return new OrgStructureLevel(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'organizations':
        return new OrganizationFormArray();
      default:
        return undefined;
    }
  }
}

export class OrgStructureLevelFormArray extends PersistedFormArray {
  readonly entityName = 'OrgStructureLevel' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(orgStructureLevelSchema, OrgStructureLevel, options);
  }

  protected override createItemGroup() {
    return new OrgStructureLevelFormGroup();
  }

  get array(): OrgStructureLevel[] {
    return this.controls.map(
      (group: OrgStructureLevelFormGroup) => group.object,
    );
  }
}

export class OrgStructureLevelPersistedArray extends PersistedArray<OrgStructureLevel> {
  readonly entityName = 'OrgStructureLevel' as const;

  constructor(options?: PersistedArrayOptions) {
    super(OrgStructureLevel, options);
  }
}
